import { useInventory } from "../src/stores/useInventory";

export default function GunModeHUD() {
  const gunMode = useInventory((state) => state.gunMode);
  const hasHeavyMachineGun = useInventory((state) => state.hasHeavyMachineGun);

  if (!gunMode || !hasHeavyMachineGun) {
    return null;
  }

  return (
    <div className="gun-mode-hint" role="status" aria-live="polite">
      Soltar [E]
    </div>
  );
}
